<template>
  <div class="print-data-header">
    <div class="pdh-job-info">
      <PrintInfoBlock
        :record="record"
        title=""
        :data="data"
      />
    </div>
    <div class="pdh-section pdh-sprinkler">
      <div class="pdhs-data">
        <div class="pdh-sprinkler-holder">
          <div class="pdh-header">Sprinkler</div>
          <div class="pdh-sprinkler-data">
            <div class="pdhs-data-col">
              <PDHInfoDisplay label="Name" :value="getSprinklerData.sprinkler"/>
              <PDHInfoDisplay label="Model" :value="getSprinklerData.model"/>
              <div class="sprinkler-placeholder"></div>
            </div>
            <div class="pdhs-data-col">
              <PDHInfoDisplay label="Plate" :value="getSprinklerData.plate" icon="Plate"/>
              <PDHInfoDisplay label="Nozzle" :value="getSprinklerData.nozzle" icon="Nozzle"/>
              <PDHInfoDisplay label="Spacing" :value="getSpacingValue" :unit="getSpacingUnit"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pdh-section">
      <div class="pdhs-data-col">
        <div class="pdh-header">Inlet</div>
        <div class="inlet-data">
          <div class="inlet-label-icon">
            <div class="inlet-inner-circle">
              <div class="in-text">IN</div>
            </div>
          </div>
          <div class="inlet-values">
            <PDHInfoDisplay label="Pressure" :value="getInletData.pressure" :unit="getPressureUnit"/>
            <PDHInfoDisplay label="Origin" :value="getInletData.origin" :unit="getSpacingUnit"/>
          </div>
        </div>
      </div>
    </div>
    <div class="pdh-section">
      <div class="pdhs-data-col">
        <div class="pdh-header">Pipe</div>
        <PDHInfoDisplay label="Pressure" icon="Pressure" :value="getPressureData.pressure" :unit="getPressureUnit"/>
        <PDHInfoDisplay label="Flow" icon="Flow" :value="getPressureData.flow" :unit="getFlowUnit"/>
        <PDHInfoDisplay label="Pressure Variation" :value="getPressureData.variation" unit="%"/>
      </div>
    </div>
  </div>
</template>

<script>
import PrintInfoBlock from '../../../components/print/sheet_components/PrintInfoBlock.vue';
import PDHInfoDisplay from '../../../components/print/sheet_components/pdh_components/PDHInfoDisplay.vue';
import * as UnitConversion from '../../../services/UnitConversionService';
import { useSprinklerStore } from '../../../store/SprinklerStore';
import { useInputStore } from '../../../store/InputStore';
import { useSettingsStore } from '../../../store/SettingsStore';
import { useSegmentStore } from '../../../store/SegmentStore';

export default {
  name: 'PrintDataHeader',
  components: {
    PrintInfoBlock,
    PDHInfoDisplay
  },
  props: [
    'record',
    'data'
  ],
  computed : {
    getSprinklerData () {
      return  {
        sprinkler: useSprinklerStore().getSprinklerSelected,
        model: useSprinklerStore().getSelectedModel,
        plate: useSprinklerStore().getSelectedPlate,
        nozzle: useSprinklerStore().getSelectedNozzle
      };
    },
    getSpacingValue () {
      return this.filterLength(useInputStore().getSprinklerSpacing);
    },
    getSpacingUnit () {
      return useSettingsStore().getLengthUnit;
    },
    getInletData () {
      return {
        pressure: this.filterPressure(useSegmentStore().getInletPressure),
        origin: this.filterLength(useSegmentStore().getInletPosition)
      };
    },
    getPressureData () {
      const formattedPipeData = useInputStore().getFormattedPipeData;
      return {
        pressure: formattedPipeData.pressureDifference,
        flow: formattedPipeData.flowDifference,
        variation: formattedPipeData.pressureVariation,
      };
    },
    getPressureUnit () {
      return useSettingsStore().getPressureUnit;
    },
    getFlowUnit () {
      return useSettingsStore().getFlowUnit;
    }
  },
  methods: {
    filterLength (length) {
      return UnitConversion.FilterLength(length, useSettingsStore().getLengthUnit);
    },
    filterPressure (pressure) {
      return UnitConversion.FilterPressure(pressure, useSettingsStore().getPressureUnit);
    },
  }
};
</script>

<style scoped>
.print-data-header {
  display: flex;
  flex: 1;
}
.pdh-job-info {
  padding-left: 30px;
  padding-right: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
}
.pdh-sprinkler {
  display: flex;
  flex-direction: row;
  gap: 20px;
}
.pdh-sprinkler-data {
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-top: 20px;
  width: 100%;
}
.pdh-header {
  font-size: 16px;
  font-weight: bold;
}
.pdh-section {
  border-left: 0.5px solid #adadad;
  padding-left: 30px;
  padding-right: 30px;
  display: flex;
}
.pdhs-data {
  display: flex;
  gap: 30px;
  width: 100%;
}
.pdhs-left {
  display: flex;
  flex-direction: column;
}
.pdhs-right {
  display: flex;
  flex-direction: column;
}
.pdhs-data-col {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  width: 100%;
}
.sprinkler-placeholder {
  width: 70px;
  height: 100px;
  border: 1px solid lightgray;
}
.inlet-values {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.inlet-data {
  display: flex;
  gap: 10px;
  align-items: c;
}
.inlet-label-icon {
  background-color: var(--inlet);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  font-size: 11px;
  align-self: center;
  transform: translateY(-11px);
}
.inlet-inner-circle {
  border: 3px solid white;
  width: 18px;
  height: 18px;
  max-width: 18px;
  max-height: 18px;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
}
.in-text {
  padding-top: 1px;
}
.sprinkler-data {
  flex-direction: column;
}
.pdh-sprinkler-holder {
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>
